<template>
  <div
    class="modal fade"
    id="checkLocalAgencyAssignmentModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
          <h4 class="modal-title">
            <b>{{ lang.CLAA00 }}</b>
          </h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="col-md-4 control-label">{{ lang.CLAA01 }}</label>
            <div class="col-md-8">
              <select2
                id="check-local-agency-assignment-select"
                class="form-control"
                ref="selectLocalAgency"
                v-model="selectedLocalAgency"
                :placeholder="lang.CLAA02"
                :allowClear="true"
              >
                <option></option>
                <option
                  v-for="agency in localAgencies"
                  :key="agency.AgencyGuid"
                  :value="agency.AgencyGuid"
                >
                  {{ agency.AgencyName }}
                </option>
              </select2>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-raised" data-dismiss="modal">
            {{ lang.CLAA03 }}
          </button>
          <button
            type="button"
            class="btn btn-raised dialog-btn-primary"
            @click="saveAgencyAssignment()"
          >
            {{ lang.CLAA04 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "../Tools/Select2";

export default {
  name: "CheckLocalAgencyAssignmentModal",
  components: {
    Select2,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    selectedChecks: {
      Type: Array,
      default: () => [],
    },
    agencies: {
      Type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedLocalAgency: "",
      lang: {
        CLAA00: "Agency assignment",
        CLAA01: "Local agency",
        CLAA02: "Please choose a local agency...",
        CLAA03: "Close",
        CLAA04: "Save",
        CLAA05: "Agency assignment request failed",
        CLAA06: "Agency assignment updated",
        CLAA07: "Assignment update failed",
      },
    };
  },
  computed: {
    localAgencies() {
      if (!this.globals.currentUserInfo.AgencyGuid || this.agencies.length < 1)
        return [];
      let lead = this.agencies.find(
        (a) =>
          a.AgencyGuid === this.globals.currentUserInfo.AgencyGuid.toUpperCase()
      );
      return lead && lead.ChildAgencies ? lead.ChildAgencies : [];
    },
  },
  watch: {
    showModal(newVal) {
      if (newVal) this.openModal();
      else this.closeModal();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    $("#checkLocalAgencyAssignmentModal").on("hide.bs.modal", (e) => {
      this.$emit("closeModal");
    });
    $("#checkLocalAgencyAssignmentModal").on("hidden.bs.modal", (e) => {
      this.$emit("modalClosed");
    });
  },
  methods: {
    openModal() {
      this.getAgencyAssignment();
      $("#checkLocalAgencyAssignmentModal").modal("show");
    },
    closeModal() {
      $("#checkLocalAgencyAssignmentModal").modal("hide");
    },
    getAgencyAssignment() {
      this.selectedLocalAgency = "";
      let sendData = { SurveyInstances: [] };
      for (let guid of this.selectedChecks) {
        sendData.SurveyInstances.push({ SurveyInstanceGuid: guid });
      }

      $.ajax({
        method: "POST",
        url: `api/SurveyInstances/AgencyAssignment/Get`,
        data: JSON.stringify(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.selectedLocalAgency = "";
          if (data.Properties && data.Properties.AssignedLocalAgencyGuid)
            this.selectedLocalAgency = data.Properties.AssignedLocalAgencyGuid;
        },
        error: () => {
          console.error("Error on POST in getAgencyAssignment()");
          this.globals.showErrorSnackbar(this.lang.CLAA05);
        },
      });
    },
    saveAgencyAssignment() {
      let sendData = {
        Properties: {
          AssignedLocalAgencyGuid: this.selectedLocalAgency,
        },
        SurveyInstances: [],
      };
      for (let guid of this.selectedChecks) {
        sendData.SurveyInstances.push({ SurveyInstanceGuid: guid });
      }

      $.ajax({
        method: "PATCH",
        url: `api/SurveyInstances/AgencyAssignment`,
        data: JSON.stringify(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.$emit("modalDataSaved");
          this.globals.showSuccessSnackbar(this.lang.CLAA06);
          this.closeModal();
        },
        error: () => {
          console.error("Error on PATCH in saveAgencyAssignment()");
          this.globals.showErrorSnackbar(this.lang.CLAA07);
        },
      });
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// CheckLocalAgencyAssignmentModal.vue?bb6ca91a